// extracted by mini-css-extract-plugin
export default {"page":"AboutPage_page__9ju+P"};